import type { StepsBreadcrumbStep } from '@/app/components/atomic/StepsBreadcrumb'
import { FAMILY_TYPE_COUPLE, FAMILY_TYPE_COUPLE_WITH_CHILDREN, FAMILY_TYPE_SINGLE } from './health-form.constants'

export const STEP_FAMILY_TYPE = 1
export const STEP_MAIN_BIRTHDAY_DATE = 2
export const STEP_MAIN_JOB = 3
export const STEP_MAIN_AGRICULTURAL_STATUS = 4
export const STEP_MAIN_ZIPCODE = 5

export const STEP_PARTNER_BIRTHDAY_DATE = 6
export const STEP_PARTNER_JOB = 7

export const STEP_CHILDREN_COUNT = 8
export const STEP_CHILDREN_1 = 9
export const STEP_CHILDREN_2 = 10
export const STEP_CHILDREN_3 = 11
export const STEP_CHILDREN_4 = 12
export const STEP_CHILDREN_5 = 13

export const STEP_EFFECTIVE_DATE = 14
export const STEP_CONTRACT = 15
export const STEP_NEEDS = 16
export const STEP_INFOS = 17

export const hasPartnerFamilyType = (familyType?: number | null): boolean =>
    familyType === FAMILY_TYPE_COUPLE || familyType === FAMILY_TYPE_COUPLE_WITH_CHILDREN

// First step of the « Votre famille » group: a single parent skips the partner steps.
export const firstFamilyStep = (familyType?: number | null): number =>
    familyType == null || hasPartnerFamilyType(familyType) ? STEP_PARTNER_BIRTHDAY_DATE : STEP_CHILDREN_COUNT

// A single adult has no family group; before the profile is known, all five groups show.
export const buildHealthBreadcrumbs = (familyType?: number | null): StepsBreadcrumbStep[] => [
    { step: STEP_FAMILY_TYPE, label: 'Votre profil' },
    ...(familyType === FAMILY_TYPE_SINGLE ? [] : [{ step: firstFamilyStep(familyType), label: 'Votre famille' }]),
    { step: STEP_EFFECTIVE_DATE, label: 'Votre contrat' },
    { step: STEP_NEEDS, label: 'Vos besoins' },
    { step: STEP_INFOS, label: 'Vos informations' },
]
